const env = {
    DEVELOPMENT: 'development',
    PRODUCTION: 'production'
}

export default Object.freeze(env)